var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/modules/_cof.js
// module id = ../../../node_modules/core-js/library/modules/_cof.js
// module chunks = 0